/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Category_StrengthInputs */

const en_us2_catalog_category_strength = /** @type {(inputs: Catalog_Category_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strength`)
};

const pt_br2_catalog_category_strength = /** @type {(inputs: Catalog_Category_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Força`)
};

const es_419_catalog_category_strength = /** @type {(inputs: Catalog_Category_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuerza`)
};

const pt_pt2_catalog_category_strength = /** @type {(inputs: Catalog_Category_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Força`)
};

const fr_fr2_catalog_category_strength = /** @type {(inputs: Catalog_Category_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Force`)
};

const de_de2_catalog_category_strength = /** @type {(inputs: Catalog_Category_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kraft`)
};

const it_it2_catalog_category_strength = /** @type {(inputs: Catalog_Category_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forza`)
};

/**
* | output |
* | --- |
* | "Strength" |
*
* @param {Catalog_Category_StrengthInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const catalog_category_strength = /** @type {((inputs?: Catalog_Category_StrengthInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Category_StrengthInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_catalog_category_strength(inputs)
	if (locale === "es-419") return es_419_catalog_category_strength(inputs)
	if (locale === "pt-PT") return pt_pt2_catalog_category_strength(inputs)
	if (locale === "fr-FR") return fr_fr2_catalog_category_strength(inputs)
	if (locale === "de-DE") return de_de2_catalog_category_strength(inputs)
	if (locale === "it-IT") return it_it2_catalog_category_strength(inputs)
	return en_us2_catalog_category_strength(inputs)
});
export { catalog_category_strength as "catalog.category.strength" }